import React, { forwardRef, useEffect, useState } from 'react'
import { DatePicker } from '@ow/comps'
import locale from '@ow/comps/locale/zh-CN'

const dealMinData = (minDate, overMinDate) => {
  if (overMinDate === 'halfYear') {
    return minDate + 24 * 60 * 60 * 1000 * 183
  }
  return minDate
}
// value参数类型 时间戳 string
const Render = function ({ opts = {}, onChange, value }) {
  const { minDate, maxDate, overMinDate } = opts
  const [defaultMinDate, setDefaultMinDate] = useState()
  const [finalMinDate, setFinalMinDate] = useState()
  const [isError, setIsError] = useState(null)
  useEffect(() => {
    if (minDate === 'current') {
      setDefaultMinDate(new Date(new Date().toDateString()))
    } else {
      setDefaultMinDate(null)
    }
    if (
      value &&
      ((minDate && (defaultMinDate || minDate) > value) ||
        (maxDate && maxDate < value)) &&
      !overMinDate
    ) {
      onChange(null)
    }
    if (overMinDate && minDate) {
      if (overMinDate === 'halfYear') {
        setIsError('请注意周期需要大于6个月')
      }
      onChange(null)
      console.log(dealMinData(minDate, overMinDate), 'ltt')
      setFinalMinDate(dealMinData(minDate, overMinDate))
    }
  }, [minDate, maxDate])

  return (
    <>
      <DatePicker
        minDate={
          defaultMinDate ||
          (finalMinDate && new Date(finalMinDate)) ||
          (minDate && new Date(minDate))
        }
        maxDate={maxDate && new Date(maxDate)}
        placeholder={opts.hint || opts.intro}
        locale={locale}
        inputStyle={{
          width: '100%',
        }}
        selectedDate={value && new Date(value)}
        onChange={(e) => {
          if (e) {
            onChange(new Date(e).getTime())
            setIsError(null)
          } else {
            onChange(null)
          }
        }}
        showTime={opts.showTime}
        showMonth={opts.showMonth}
        monthType="picker"
        disabled={opts.readonly}
        // 组件应提供默认值
        selectedDateBackground="rgb(var(--ow-primary-color))"
      />
      {isError && (
        <p style={{ color: 'rgb(var(--ow-primary-color))' }} className="mt-2">
          {isError}
        </p>
      )}
    </>
  )
}

export default forwardRef(Render)
